import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { api } from "../../services/api";
import { endpoints } from "../../services/endpoints";

export default function ResetPassword() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const token = searchParams.get("token");
  const [isTokenError, setIsTokenError] = useState(false);

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setIsTokenError(false);

    if (!token) {
      setError(
        t("resetPassword.errors.invalidToken", {
          defaultValue:
            "Este enlace ya no es válido. Solicita uno nuevo para restablecer tu contraseña.",
        })
      );
      setIsTokenError(true);
      return;
    }

    if (password !== confirm) {
      setError(
        t("resetPassword.errors.mismatch", {
          defaultValue: "Las contraseñas no son iguales",
        })
      );
      return;
    }

    setLoading(true);
    try {
      await api.post(endpoints.auth.resetPassword, {
        token,
        new_password: password,
      });

      setSuccess(true);
    } catch (err) {
      setError(
        t("resetPassword.errors.invalidToken", {
          defaultValue:
            "Este enlace ya no es válido. Solicita uno nuevo para restablecer tu contraseña.",
        })
      );
      setIsTokenError(true);
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
        <div className="bg-white p-6 rounded shadow w-full max-w-md text-center space-y-4">
          <h1 className="text-xl font-semibold">
            {t("resetPassword.success.title", {
              defaultValue: "Contraseña actualizada",
            })}
          </h1>
          <button
            onClick={() => navigate("/login")}
            className="w-full bg-[#01839C] text-white py-2 rounded"
          >
            {t("resetPassword.success.login", {
              defaultValue: "Ir al login",
            })}
          </button>
        </div>
      </div>
    );
  }

return (
  <div className="min-h-screen flex flex-col relative">
    {/* Fondo con opacidad */}
    <div className="absolute left-0 w-full h-full bg-black opacity-60 z-0">
      <img
        src="/img/backend.webp"
        alt={t("resetPassword.backgroundAlt", {
          defaultValue: "Background",
        })}
        className="w-full h-full object-cover object-center"
      />
    </div>
    <div className="min-h-screen flex items-center justify-center px-4 relative z-10">
      <form
        onSubmit={handleSubmit}
        className="bg-white p-6 rounded shadow w-full max-w-md space-y-4"
      >
        <h1 className="text-xl font-semibold text-center">
          {t("resetPassword.title", {
            defaultValue: "Nueva contraseña",
          })}
        </h1>

        <input
          type="password"
          placeholder={t("resetPassword.fields.password", {
            defaultValue: "Nueva contraseña",
          })}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          className="w-full border px-3 py-2 rounded"
        />

        <input
          type="password"
          placeholder={t("resetPassword.fields.confirm", {
            defaultValue: "Confirmar contraseña",
          })}
          value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
          required
          className="w-full border px-3 py-2 rounded"
        />

        <button
          type="submit"
          disabled={loading}
          className="w-full bg-[#01839C] text-white py-2 rounded hover:bg-[#016b7c] disabled:opacity-70"
        >
          {loading
            ? t("common.loading", { defaultValue: "Guardando…" })
            : t("resetPassword.actions.submit", {
                defaultValue: "Guardar",
              })}
        </button>

        {error && (
          <p className="text-red-600 text-sm">
            {error}
            {isTokenError && (
              <>
                {" "}
                <a
                  href="/forgot-password"
                  className="underline text-[#01839C]"
                >
                  {t("resetPassword.actions.requestNewLink", {
                    defaultValue: "Solicitar nuevo enlace",
                  })}
                </a>
              </>
            )}
          </p>
        )}

      </form>

    </div>
     
    </div>
  );
}
